<template>
  <v-card>
    <v-card-title class="title">
      <v-icon class="mr-2">link</v-icon>
      <div>Linked Services</div>
    </v-card-title>
    <v-card-text>
      <div>
        These service links are used throughout the UI and must be linked to a service. If they are not linked they will not function properly.
      </div>
      <v-chip v-for="(link, index) in serviceLinks" :key="`missing-link-${index}`" small>
        <v-icon class="mr-1" :color="link.ServiceId ? 'success' : 'error'" v-html="link.ServiceId ? 'done' : 'clear'" />
        {{ splitCapitalizeByChar(link.ServiceLink, '_') }}
      </v-chip>
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    splitCapitalizeByChar,
  } from '@/helpers/strings'

  import { createNamespacedHelpers } from 'vuex'
  const app = createNamespacedHelpers('app')
  const linkedServices = createNamespacedHelpers('linkedservices')

  export default {
    props: {
      services: Array,
      isLoaded: Boolean,
    },
    data: () => ({
      pagination: {
        rowsPerPage: -1,
      },
      loaded: {
        linkedServices: false,
      },
    }),
    computed: {
      ...linkedServices.mapState(['serviceLinks']),
      loading() {
        return !(this.loaded.linkedServices && this.isLoaded)
      },
    },
    methods: {
      ...linkedServices.mapActions(['getLinkedServices']),
      ...app.mapActions(['setSnackbar']),
      splitCapitalizeByChar,
      findService(linkedService, services) {
        return services.find(service => service.LinkedServiceId && service.LinkedServiceId == linkedService.Id)
      },
      async fetchServiceLinks() {
        try {
          await this.getLinkedServices()
        } catch (error) {
          console.error(error)
          this.setSnackbar({
            text: 'Couldn\'t load use cases, please see console.',
            color: 'error',
            icon: 'error',
          })
        }

        this.loaded.linkedServices = true
      },
    },
    mounted() {
      this.fetchServiceLinks()
    },
  }
</script>